'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'cherries';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M285.7-23.9c8.7-.8 17.2 3.2 22.2 10.4L448.1 193.1c5.2-.7 10.5-1.1 15.9-1.1 61.9 0 112 50.1 112 112 0 97.2-86 176-192 176-13.3 0-26.3-1.2-38.8-3.6 16.7-12.9 31.5-27.8 44-44.5 80.8-2.5 138.8-62.5 138.8-127.9 0-35.3-28.7-64-64-64-15.1 0-29 5.2-40 14-4.1-12.6-9.8-24.5-16.8-35.5L292.8 49.8 228 201c13.5-5.8 28.4-9 44-9 61.9 0 112 50.1 112 112 0 97.2-86 176-192 176S0 401.2 0 304c0-61.9 50.1-112 112-112 22.1 0 42.7 6.4 60.1 17.5L265.9-9.5c3.5-8.1 11-13.6 19.8-14.4zM192 273.6c-12.9 0-25.3-5.2-34.3-14.4-11.7-11.9-27.8-19.2-45.7-19.2-35.3 0-64 28.7-64 64 0 66.8 60.5 128 144 128s144-61.2 144-128c0-35.3-28.7-64-64-64-17.9 0-34 7.3-45.7 19.2-9 9.2-21.4 14.4-34.3 14.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;